<template>
<div class="wrap_videoblockselect  wow  fadeInUp">
   <el-row >
  <el-col :span="2" class="header_block"></el-col>
  <el-col :span="20" class="header_block">
  <div class="video_tv  wow  fadeInUp" >
    
    <div class="caseshowselect">精选案例</div> 
    <div class="caseshow">CASE SHOW</div>
    <div class="caseshowblock"></div>
    <div class="caseshowline"></div>
  </div>
   <!-- <div class="video_text  wow  fadeInUp" @click="jumpServiceBFn()">宣传视频</div> -->
   </el-col>
<el-col :span="2" class="header_block"></el-col> 

 </el-row >
 <el-row >
  <el-col :span="2" class="header_block"></el-col>
  <el-col :span="20" class="header_block">
    <!-- <el-row :gutter="20" v-for="(item,index) in videoArray" :key="index">
      <el-col  v-for="(itm,inx) in item" :key="inx" :span="spancols" class="header_block">
        <div class="big_video_box " @click="selectPics(index,inx)">
          <div class="mask_title">{{itm.text}}</div>
                <img class="mask_boxs" :src="itm.url" alt="2020体彩竞猜广告-去赛场篇">
                 <i class="shark"></i>
        </div>
      </el-col>
      </el-row> -->

      <!-- <div  v-for="(item,index) in videoArray" :key="index">
      <div  v-for="(itm,inx) in item" :key="inx"  > -->
        <div class="big_video_box " @click="selectPics(index)" v-for="(item,index) in videoArray" :key="index" >
          
          <img class="mask_boxs" :src="item.url" alt="2020体彩竞猜广告-去赛场篇">
          <i class="shark"></i>
          <div class="mask_title">{{item.text}}</div>
      </div>
        
      <!-- </div>
      </div> -->

  </el-col>
  <el-col :span="2" class="header_block"></el-col>
</el-row>
</div>

</template>

<script>
export default {
  name: 'videoBlock',
  props: {
    videoArray: {
      type: Array,
      default: () => { 
        return []
      },
    },
    spancols:{
      type: Number,
      default:12,
    },
    flagIndex: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      // serviceArray:[
      //   {url:require('@/assets/imgs/a01.png'),title:'商业视频',titleEng:'Commercial video'},
      //   {url:require('@/assets/imgs/a02.png'),title:'短视频',titleEng:'short video'},
      //   {url:require('@/assets/imgs/a01.png'),title:'视频课程',titleEng:'video course'},
      //   {url:require('@/assets/imgs/a03.png'),title:'多媒体展示',titleEng:'multimedia show'},
      // ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },

  // mounted(){
  // 　　window.addEventListener('scroll',this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  // },
  methods:{
    selectPics(index){
      this.$emit('selectPics',index)

    },
    jumpServiceBFn() {
        document.documentElement.scrollTop = 0;
        this.$router.push({
          name: 'casepage',
        })
    },
  //   handleScroll(){
  //     this.$nextTick(()=>{
	// 	let scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  //    if (scrollTop > 60) {
  //      this.logoIndex = 1
  //      this.classNames = "nav_bg_white_add"
  //      this.menuClassNames = "menu_each each_toggle"
  //       } else {
  //      this.logoIndex = 0
  //      this.classNames = "nav_bg_white_reduce"
  //      this.menuClassNames = "menu_each "
  //       }
	// })
  //   }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrap_videoblockselect{
  .video_tv {
    width: 100%;
    font-family: 微软雅黑;
    text-align: left;
    height: 60px;
    float: left;
    position: relative;
    margin-bottom: 40px;
}
.caseshowselect{
  width: 115px;
  float: left;
  font-size: 24px;
  color: #000;
  vertical-align: middle;
  position:absolute;bottom:0
}
.caseshow{
  width: 100px;
  float: left;
  font-size: 14px;
    color: #737373;
    
    vertical-align: middle;
    position:absolute;bottom:0;
    left:115px
}
.caseshowblock{
  width: 6px;
  height: 9px;
  float: left;
  background: #e91d62;
  margin-top: 51px;
   position:absolute;bottom:0;
    left:215px
}
.caseshowline{
  width: calc((100% - 221px));
  // margin-left: 15px;
  height: 9px;
  float: left;
  background: #d5d5d5;
  // background: green;
  margin-top: 51px;
  position:absolute;bottom:0;
  left:221px
}
.video_text {
    font-size: 12px;
    color: rgb(178, 178, 178);
    font-family: 微软雅黑;
    text-align: left;
    line-height: 30px;
    margin-bottom: 20px;
    margin-left: 50px;
}
  .header_block{
    min-height: 10px;
  }
  .big_video_box{
    width: calc((100% - 20px) * 0.33333);
    margin-right: 10px ;
    float: left;
    position: relative;
    .mask_title{
      font-size: 14px;
    color: #666;
    // position: absolute;
    // top: 0px;
    // left: 0;
    width: 100%;
    z-index: 3;
    text-align: center;
    height: 50px;
    line-height: 40px;
    // border-bottom: 1px solid #fff;
    /* border-radius: 0px 0px 5px 5px; */
    }
    
    .mask_boxs{
       width: 100%;
       border: 1px solid #DBDBDB;
       box-sizing: border-box;
       border-radius: 5px;
    }
    .shark{
      width: 52px;
    height: 52px;
    background: url(../assets/imgs/play.png) center center no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, calc(-50% - 25px));
    z-index: 33;
    }
  }
  .big_video_box:nth-child(3n){
      margin-right: 0;
    }
  }
</style>



